const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
        padding: "2vw",
        boxSizing: "border-box"
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh"
    },
    header: {
        marginBottom: "2vw"
    },
    paper: {
        padding: "3vw",
        maxWidth: "800px",
        margin: "0 auto",
        width: "100%"
    },
    title: {
        fontWeight: 700,
        marginBottom: "2vw",
        textAlign: "center",
        color: (theme) => theme.palette.primary.main
    },
    exportInfo: {
        backgroundColor: "#f5f5f5",
        padding: "1.5vw",
        borderRadius: "8px",
        marginBottom: "2vw",
        '& > *': {
            marginBottom: "0.5vw"
        }
    },
    uploadSection: {
        marginTop: "2vw",
        marginBottom: "2vw"
    },
    fileInfo: {
        display: "flex",
        alignItems: "center",
        gap: "1vw",
        marginTop: "1vw",
        padding: "1vw",
        backgroundColor: "#e8f5e9",
        borderRadius: "8px"
    },
    actions: {
        display: "flex",
        gap: "1vw",
        justifyContent: "center",
        marginTop: "2vw"
    }
}

export default styles;

